import { useState, useRef } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ContactPage from "./ContactPage";
import "react-lazy-load-image-component/src/effects/blur.css";

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  const handleNextSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % 5);
  };
  const handleClicked = () => {
    navigate("/contactform");
  };
  return (
    <div>
      <section className="section1">
        <div>
          <div className="serviceclass1">
            <img src="/images/background.webp" alt="" />
          </div>
          <div className="serviceclass2">
            <h4 className="fsh2 mb2 serviceclass2h4">Our Services</h4>
            <p className="webservicep fsp col-10">
              We specialize in E-Commerce Development, creating seamless,
              high-performing online stores that drive sales and enhance user
              experience. Our expertise includes custom e-commerce website
              design, secure payment gateway integration, mobile-friendly
              interfaces.
            </p>
            <button
              className="button"
              style={{ textAlign: "right" }}
              onClick={handleClicked}
            >
              <span className="text">Let's Talk &rarr;</span>
              <div className="circle"></div>
            </button>
          </div>
        </div>
      </section>
      <section className="m lottooffer">
        <div ref={sectionRef} className="services-section">
          <h2 className="sersech2 fsh2 mb2">OUR SERVICES</h2>
          <h3 className="sersecp mb2 fsh3">
            We have a lot to offer, these are just some of them
          </h3>
          <div className="tab-buttons">
            {[
              "UI/UX Design",
              "Web Technology",
              "Mobile App Technology",
              "Digital Marketing",
              "Custom Software Solutions"
            ].map((service, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`fsp flex-shrink-0 mx-2 ${
                  activeIndex === index ? "active" : ""
                }`}
              >
                {service}
              </button>
            ))}
          </div>

          <div className="content-container">
            <div className={`content-box ${activeIndex === 0 ? "active" : ""}`}>
              <div className="cb1 flex-column">
                <div className="cb2">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div>
                      <img
                        src="/images/4.webp"
                        alt=""
                        className="imag1 img-fluid"
                        height="30px"
                        width="60px"
                      />
                      <img
                        src="/images/3.webp"
                        alt=""
                        className="imag2 img-fluid"
                        height="30px"
                        width="60px"
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <img
                        src="/images/ui.webp"
                        alt=""
                        className="imag5 img-fluid"
                        height="40px"
                        width="160px"
                      />
                      <img
                        src="/images/ux.webp"
                        alt=""
                        className="imag5 img-fluid"
                        height="40px"
                        width="160px"
                      />
                    </div>
                    <div>
                      <img
                        src="/images/2.webp"
                        alt=""
                        className="imag3 img-fluid"
                        height="30px"
                        width="60px"
                      />
                      <img
                        src="/images/1.webp"
                        alt=""
                        className="imag4 img-fluid"
                        height="30px"
                        width="60px"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <img
                    src="/images/panel.webp"
                    alt=""
                    className="img-fluid"
                    style={{
                      height: "220px",
                      display: "flex",
                      alignItems: "left"
                    }}
                  />
                </div>
              </div>
              <div className="uiuxmobileres text-start">
                <h3 className="fsh3">UI/UX Designing</h3>
                <p className="fsp">
                  We specialize in designing high-quality layouts for both web
                  and mobile applications, utilizing industry-leading tools such
                  as Figma, Sketch, and Adobe XD. Our team focuses on crafting
                  visually appealing, intuitive, and responsive designs that
                  ensure an outstanding user experience. We create user-friendly
                  interfaces that enhance functionality and provide engagement
                  across all devices.
                </p>
                <div className="tags">
                  {[
                    "Experience Design",
                    "Interface Design",
                    "Strategy & Consulting"
                  ].map((text, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        src="/images/tick.webp"
                        height="30px"
                        width="30px"
                        alt=""
                        style={{ height: "30px", width: "30px" }}
                      />
                      <span className="fsp">{text}</span>
                    </div>
                  ))}
                </div>
                <div className="uiux d-flex flex-wrap mt-3">
                  {[
                    "figma",
                    "xd",
                    "ps",
                    "ai",
                    "adobe",
                    "sketch",
                    "miro",
                    "framer"
                  ].map((tool, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        src={`/images/${tool}.webp`}
                        alt=""
                        style={{ height: "35px" }}
                        height="35px"
                        width="35px"
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="down-arrow" onClick={handleNextSlide}>
                <button className="button" onClick={handleClicked}>
                  <span className="text1">Get Quote &rarr;</span>
                  <div className="circle1"></div>
                </button>
                <FaArrowRight className="down-arrow1" size={30} />
              </div>
            </div>

            <div className={`content-box ${activeIndex === 1 ? "active" : ""}`}>
              <div className="cb1 flex-column">
                <div className="cb2 ">
                  <div className="d-flex flex-column justify-content-center align-items-start gap-2">
                    <img
                      src="/images/Fontend1.webp"
                      alt=""
                      className="img-fluid imag5"
                      height="18px"
                      width="90%"
                      style={{
                        height: "18px",
                        width: "90%",
                        objectFit: "cover"
                      }}
                    />
                    <img
                      src="/images/Fontend2.webp"
                      alt=""
                      className="img-fluid imag6"
                      style={{
                        height: "18px",
                        width: "90%",
                        objectFit: "fill"
                      }}
                    />
                    <img
                      src="/images/Fontend3.webp"
                      alt=""
                      className="img-fluid imag7"
                      height="18px"
                      width="18px"
                      style={{ height: "18px", objectFit: "cover" }}
                    />
                    <img
                      src="/images/Fontend4.webp"
                      alt=""
                      className="img-fluid imag8"
                      style={{
                        height: "18px",
                        width: "90%",
                        objectFit: "fill"
                      }}
                    />
                    <img
                      src="/images/Master Of People.webp"
                      alt=""
                      className="img-fluid imag9"
                      style={{
                        height: "22px",
                        width: "90%",
                        objectFit: "contain"
                      }}
                    />
                  </div>
                </div>
                <div>
                  <img
                    src="/images/fed.webp"
                    alt=""
                    className="img-fluid"
                    height="220px"
                    width="220px"
                    style={{
                      height: "220px",
                      display: "flex",
                      alignItems: "left"
                    }}
                  />
                </div>
              </div>
              <div className="uiuxmobileres text-start">
                <h3 className="fsh3">Web development</h3>
                <p className="fsp">
                  We have a highly experienced team that offers the best
                  customized website services using advanced technologies like
                  PHP, React Native, ReactJS, AngularJS, HTML5, and CSS3 to
                  build a high-quality website and deliver the best results.
                </p>
                <div className="tags pt-3 gap-2">
                  {[
                    "Frontend Development",
                    "Backend Development",
                    "Database Integration"
                  ].map((text, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        src="/images/tick.webp"
                        height="30px"
                        width="30px"
                        alt=""
                        style={{ height: "30px", width: "30px" }}
                      />
                      <span className="fsp">{text}</span>
                    </div>
                  ))}
                </div>
                <div className="webtech d-flex flex-wrap gap-4 mt-3">
                  {[
                    "angular",
                    "bootstrap5",
                    "css3",
                    "html5",
                    "js",
                    "reactjs",
                    "php",
                    "nextjs",
                    "wordpress",
                    "mysql"
                  ].map((tech, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        height="30px"
                        width="30px"
                        src={`/images/${tech}.webp`}
                        alt=""
                        style={{ height: "30px" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="down-arrow" onClick={handleNextSlide}>
                <button className="button" onClick={handleClicked}>
                  <span className="text1">Get Quote &rarr;</span>
                  <div className="circle1"></div>
                </button>
                <FaArrowRight className="down-arrow1" size={30} />
              </div>
            </div>

            <div className={`content-box ${activeIndex === 2 ? "active" : ""}`}>
              <div className="cb1 flex-column ">
                <div className="cb2 ">
                  <div className="text-center">
                    <div className="d-flex justify-content-center align-items-start gap-3">
                      <div>
                        <img
                          src="/images/Android.webp"
                          alt="Android"
                          className="img-fluid p-1"
                          style={{
                            height: "50px",
                            width: "50px",
                            objectFit: "contain"
                          }}
                        />
                        <img
                          src="/images/Apple Store.webp"
                          alt="Apple Store"
                          className="img-fluid p-1"
                          style={{
                            height: "50px",
                            width: "70%",
                            objectFit: "contain"
                          }}
                        />
                      </div>
                      <div>
                        <img
                          src="/images/Apple.webp"
                          alt="Apple"
                          className="img-fluid p-1"
                          height="50px"
                          width="50px"
                          style={{
                            height: "50px",
                            objectFit: "contain",
                            alignItems: "flex-start"
                          }}
                        />
                        <img
                          src="/images/Play Store.webp"
                          alt="Play Store"
                          className="img-fluid p-1"
                          height="50px"
                          width="90%"
                          style={{
                            height: "50px",
                            width: "90%",
                            objectFit: "contain"
                          }}
                        />
                      </div>
                    </div>
                    <img
                      src="/images/Master Of People.webp"
                      alt="Master Of People"
                      className="img-fluid p-1"
                      height="22px"
                      width="90%"
                      style={{
                        height: "22px",
                        width: "90%",
                        objectFit: "contain"
                      }}
                    />
                  </div>
                </div>
                <div>
                  <img
                    src="/images/appdev.webp"
                    alt="App Development"
                    className="img-fluid"
                    height="220px"
                    width="220px"
                    style={{
                      height: "220px",
                      display: "flex",
                      alignItems: "left"
                    }}
                  />
                </div>
              </div>
              <div className="uiuxmobileres text-start">
                <h3 className="fsh3">Mobile App Development</h3>
                <p className="fsp">
                  Our mobile app development services provide custom solutions
                  for both iOS and Android platforms. We focus on innovative,
                  user-friendly apps with functionality and excellent
                  performance. Our team ensures that each app is designed to
                  meet your business needs while offering a smooth user
                  experience.
                </p>
                <div className="tags pt-3 gap-2">
                  {[
                    "Front-end development",
                    "Back-end development",
                    "iOS/Android"
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        src="/images/tick.webp"
                        height="30px"
                        width="30px"
                        alt="Tick"
                        style={{ height: "30px", width: "30px" }}
                      />
                      <span className="fsp">{item}</span>
                    </div>
                  ))}
                </div>
                <div className="webtech d-flex flex-wrap gap-5 mt-3">
                  {[
                    "ad.webp",
                    "dart.webp",
                    "firebase.webp",
                    "flutter.webp",
                    "github (1).webp",
                    "kotlin.webp",
                    "vscode.webp",
                    "postman.webp"
                  ].map((img, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        src={`/images/${img}`}
                        alt={img}
                        style={{ height: "30px" }}
                        height="30px"
                        width="30px"
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="down-arrow" onClick={handleNextSlide}>
                <button className="button" onClick={handleClicked}>
                  <span className="text1">Get Quote &rarr;</span>
                  <div className="circle1"></div>
                </button>
                <FaArrowRight className="down-arrow1" size={30} />
              </div>
            </div>

            <div className={`content-box ${activeIndex === 3 ? "active" : ""}`}>
              <div className="cb1 flex-column ">
                <div className="cb2">
                  <div>
                    <div className="d-flex justify-content-center align-items-start gap-3">
                      <div>
                        <img
                          src="/images/Android.webp"
                          alt=""
                          className="img-fluid p-1"
                          style={{
                            height: "50px",
                            width: "50px",
                            objectFit: "contain"
                          }}
                        />
                        <img
                          src="/images/Apple Store.webp"
                          alt=""
                          className="img-fluid p-1"
                          style={{
                            height: "50px",
                            width: "70%",
                            objectFit: "contain"
                          }}
                        />
                      </div>
                      <div>
                        <img
                          src="/images/Apple.webp"
                          alt=""
                          className="img-fluid p-1"
                          height="50px"
                          width="50px"
                          style={{
                            height: "50px",
                            objectFit: "contain",
                            alignItems: "flex-start"
                          }}
                        />
                        <img
                          src="/images/Play Store.webp"
                          alt=""
                          className="img-fluid p-1"
                          style={{
                            height: "50px",
                            width: "90%",
                            objectFit: "contain"
                          }}
                        />
                      </div>
                    </div>
                    <img
                      src="/images/Master Of People.webp"
                      alt=""
                      className="img-fluid p-1"
                      style={{
                        height: "22px",
                        width: "90%",
                        objectFit: "contain"
                      }}
                    />
                  </div>
                </div>
                <div>
                  <img
                    src="/images/dm.webp"
                    alt=""
                    height="220px"
                    width="220px"
                    className="img-fluid d-flex align-items-start"
                    style={{ height: "220px" }}
                  />
                </div>
              </div>

              <div className="uiuxmobileres text-start">
                <h3 className="fsh3">Digital Marketing</h3>
                <p className="fsp">
                  Our digital marketing services help your business grow online
                  by enhancing your brand visibility. We offer tailored
                  strategies in SEO, social media marketing, content creation,
                  and paid advertising. Our goal is to drive traffic, increase
                  conversions, and maximize ROI, ensuring measurable results for
                  your business success.
                </p>

                <div className="tags pt-3 gap-3">
                  {[
                    "Search Engine Optimization",
                    "Social Media Marketing",
                    "Pay Per Click Advertising"
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        src="/images/tick.webp"
                        height="30px"
                        width="30px"
                        alt=""
                        className="img-fluid"
                        style={{ height: "30px", width: "30px" }}
                      />
                      <div className="fsp">{item}</div>
                    </div>
                  ))}
                </div>

                <div className="digimark d-flex flex-wrap gap-4">
                  {[
                    "openai",
                    "meta",
                    "canva",
                    "analytics",
                    "yt",
                    "ln",
                    "ig",
                    "v",
                    "b",
                    "ana"
                  ].map((icon, index) => (
                    <div key={index} className="d-flex align-items-center">
                      <img
                        src={`/images/${icon}.webp`}
                        alt=""
                        className="img-fluid"
                        style={{ height: "30px" }}
                        height="30px"
                        width="30px"
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="down-arrow" onClick={handleNextSlide}>
                <button className="button" onClick={handleClicked}>
                  <span className="text1">Get Quote &rarr;</span>
                  <div className="circle1"></div>
                </button>
                <FaArrowRight className="down-arrow1" size={30} />
              </div>
            </div>

            <div className={`content-box ${activeIndex === 4 ? "active" : ""}`}>
              <div className="cb1 flex-column">
                <div className="cb2">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div>
                      <img
                        src="/images/4.webp"
                        alt=""
                        className="imag1"
                        height="30px"
                        width="60px"
                      />
                      <img
                        src="/images/3.webp"
                        alt=""
                        className="imag2"
                        height="30px"
                        width="60px"
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <img
                        src="/images/ui.webp"
                        alt=""
                        className="imag5"
                        height="30px"
                        width="60px"
                      />
                      <img
                        src="/images/ux.webp"
                        alt=""
                        className="imag5"
                        height="30px"
                        width="60px"
                      />
                    </div>
                    <div>
                      <img
                        src="/images/2.webp"
                        alt=""
                        className="imag3"
                        height="30px"
                        width="60px"
                      />
                      <img
                        src="/images/1.webp"
                        alt=""
                        className="imag4"
                        height="30px"
                        width="60px"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <img
                    src="/images/cssol.webp"
                    height="220px"
                    width="220px"
                    alt=""
                    style={{
                      height: "220px",
                      display: "flex",
                      alignItems: "flex-start"
                    }}
                  />
                </div>
              </div>
              <div className="uiuxmobileres text-start">
                <h3 className="fsh3">Custom software solutions</h3>
                <p className="fsp">
                  Take your business to the next level with custom software
                  solutions designed just for you. Our team creates efficient
                  and user-friendly software that boosts productivity,
                  simplifies operations, and increases growth. Whether you need
                  a web app, mobile solution or enterprise system, we build
                  innovative technology that fits your unique goals.
                </p>
                <div className="tags">
                  {[
                    "Custom UI/UX Design",
                    "Custom Web Development",
                    "Custom App Development"
                  ].map((text, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <img
                        src="/images/tick.webp"
                        height="30px"
                        width="30px"
                        alt=""
                        style={{ height: "30px", width: "30px" }}
                      />
                      <div className="fsp">{text}</div>
                    </div>
                  ))}
                </div>
                <div className="uiux d-flex flex-wrap">
                  {[
                    "cus1",
                    "cus5",
                    "cus2",
                    "cus6",
                    "cus7",
                    "cus3",
                    "cus4",
                    "framer"
                  ].map((img, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <img
                        src={`/images/${img}.webp`}
                        alt=""
                        style={{ height: "35px" }}
                        height="35px"
                        width="35px"
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="down-arrow" onClick={handleNextSlide}>
                <button className="button" onClick={handleClicked}>
                  <span className="text1">Get Quote &rarr;</span>
                  <div className="circle1"></div>
                </button>
                <FaArrowRight className="down-arrow1" size={30} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <ContactPage />
      </section>
    </div>
  );
};

export default Services;
